// deps
import React, { ReactElement, memo } from "react";

// styles
import styles from "./BannerMessage.scss";

// test-ids
import { BANNER_MESSAGE_TEST_ID } from "@swiggy-private/payment-test-ids";

interface BannerMessageProps {
    message: string;
}

/**
 * Payment Banner use to show fixed banner message
 * Use to render `cartBannerMessage`, `paymentBannerMessage`
 * @param props
 */
export const BannerMessage = memo(function BannerMessage({ message }: BannerMessageProps): ReactElement | null {
    if (message.trim().length === 0) {
        return null;
    }

    return (
        <div className={styles.container}>
            <div className={styles.containerLabel} data-testid={BANNER_MESSAGE_TEST_ID}>
                {message}
            </div>
        </div>
    );
});
